import { useEffect, useMemo, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  IconButton,
  Modal,
  Box,
  Snackbar,
  Alert,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import axiosInstance from "../../../API/axiosInstance";

const FleetDailyReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [rideEnd, setrideEnd] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("token");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success",
  );
  const [getStatusValue, setGetStatusValue] = useState<any>();

  const [fieldvalueData, setfieldvalueData] = useState({
    userId: "",
    firstName: "",
    lastName: "",
    mobile: "",
    vehicleNo: "",
    address: "",
    gender: "",
    dateOfBirth: "",
  });

  const userData = useMemo(() => {
    return location.state || {};
  }, [location.state]);
  const vehicleNumber = userData.vehicleNo;
  const EbNumber = userData.vehicleNo;

  const userId = userData.userId;
  const adharCardVerification = async (userId: string | number) => {
    try {
      await axiosInstance.post(
        "/users/dashboard/verify-aadhaar",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { userId },
        },
      );
      setSnackbarMessage("Aadhaar Card Verification Successful");
      setSnackbarSeverity("success");
      setShowErrorSnackbar(true);
    } catch {
      setSnackbarMessage("Aadhaar Card Verification Failed");
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  };
  useEffect(() => {

    if (userData) {
      setfieldvalueData({
        userId: userData.userId || "",
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        mobile: userData.mobile || "",
        vehicleNo: userData.vehicleNo || "",
        address: userData.address || "",
        gender: userData.gender || "",
        dateOfBirth: userData.dateOfBirth || "",
      });
    }
  }, [userData]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setfieldvalueData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle gender change specifically
  const handleGenderChange = (e: any) => {
    setfieldvalueData((prev) => ({
      ...prev,
      gender: e.target.value,
    }));
  };

  useEffect(() => {
    if (EbNumber) {
      ZyppLiteApi.api?.getStatus(EbNumber).then((response) => {
        if (response?.data) {
          setGetStatusValue(response.data);
        }
      });
    }
  }, [EbNumber]);

  useEffect(() => {
    if (userId && vehicleNumber) {
      ZyppLiteApi.api
        ?.getStatusRideEnd({ userId, vehicleNumber })
        .then((response) => {
          if (response?.data) {
            setrideEnd(response.data.ridesStatus);
          }
        });
    }
  }, [userId, vehicleNumber]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Validation only for update vehicle flow
    if (
      !userData.isActive &&
      (!fieldvalueData.userId || !fieldvalueData.vehicleNo?.trim())
    ) {
      alert("User ID and Vehicle Number are required");
      return;
    }

    setIsSubmitting(true);

    try {
      // if (userData.isActive && getStatusValue) {
      //   // Call lock/unlock API based on status
      //   const motorApiUrl =
      //     getStatusValue === "UNLOCK"
      //       ? `/socket/api/v1/motor/lock?vehicleNo=${EbNumber}`
      //       : `/socket/api/v1/motor/unlock?vehicleNo=${EbNumber}`;

      //   await axiosInstance.get(motorApiUrl, {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   });

      //   // Show success modal for motor lock/unlock
      //   setOpen(true);
      //   setTimeout(() => {
      //     setOpen(false);
      //     navigate("/userdetails", { state: { tabIndex: 1 } });
      //   }, 3000);
      // }

      if (!userData.isActive) {
        // Only run when "Update Vehicle Number" button is clicked
        const response = await axiosInstance.post(
          `/users/dashboard/edit-user-vehicle-mapping?userId=${userData.userId}&vehicleNo=${fieldvalueData.vehicleNo}`,
          { vehicleNumber: fieldvalueData.vehicleNo },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response?.status === 200) {
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
            navigate("/userdetails", { state: { tabIndex: 1 } });
          }, 5000);
        } else {
          setSnackbarMessage(response.data?.message || "Error updating user");
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      }
    } catch (error: any) {
      console.error("Error:", error);
      if (axios.isAxiosError(error) && error.response) {
        setSnackbarMessage(
          error.response.data?.message || "Operation failed. Please try again.",
        );
      } else {
        setSnackbarMessage("Network error or server unreachable.");
      }
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const rideEndRequest = async (userId: any) => {
    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post(
        `/users/dashboard/initiate-ride-end`,
        { userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response?.status === 200) {
        setSnackbarMessage("Ride end initiated successfully.");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);

        // Show success modal instead of reload
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          navigate("/userdetails", { state: { tabIndex: 1 } });
        }, 3000);
      } else {
        setSnackbarMessage("Failed to initiate ride end.");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error) {
      console.error("API call error:", error);
      if (axios.isAxiosError(error) && error.response) {
        setSnackbarMessage(
          error.response.data?.message || "Failed to update. Please try again.",
        );
      } else {
        setSnackbarMessage("Network error or server unreachable.");
      }
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const updateDataRequest = async (userId: any) => {
    console.log("Updating data:", fieldvalueData);
    setIsSubmitting(true);

    try {
      const response = await axiosInstance.put(
        `/users/dashboard/edit/users-details`,
        { ...fieldvalueData, userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Connection: "keep-alive",
            "Content-Type": "application/json",
          },
        },
      );

      if (response?.status === 200) {
        setSnackbarMessage("Data updated successfully.");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);

        // Show success modal instead of reload
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          navigate("/userdetails", { state: { tabIndex: 1 } });
        }, 3000);
      } else {
        setSnackbarMessage("Failed to update Data.");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error) {
      console.error("API call error:", error);
      if (axios.isAxiosError(error) && error.response) {
        setSnackbarMessage(
          error.response.data?.message || "Failed to update. Please try again.",
        );
      } else {
        setSnackbarMessage("Network error or server unreachable.");
      }
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDownloadAadhaar = async (
    userId: string,
    userData: { name: string },
  ) => {
    try {
      const response = await axiosInstance.get(
        `/users/dashboard/download-aadhaar?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const { code, data } = response.data || {};
      const userDocMap = data?.userDocMap;

      if (code !== 2000 || !userDocMap) {
        throw new Error("Aadhaar documents not found.");
      }

      const downloadImage = async (url: string, filename: string) => {
        try {
          const imgResponse = await axios.get(url, { responseType: "blob" });
          const blobUrl = window.URL.createObjectURL(
            new Blob([imgResponse.data]),
          );
          const link = document.createElement("a");
          link.href = blobUrl;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (err) {
          console.error("Blob download failed", err);
          window.open(url, "_blank");
        }
      };

      if (userDocMap.FRONT) {
        await downloadImage(
          userDocMap.FRONT,
          `${fieldvalueData.firstName || userData.name} Front Aadhaar Card.jpg`,
        );
      }

      if (userDocMap.BACK) {
        await downloadImage(
          userDocMap.BACK,
          `${fieldvalueData.firstName || userData.name} Back Aadhaar Card.jpg`,
        );
      }

      setSnackbarMessage("Aadhaar FRONT and BACK downloaded successfully");
      setSnackbarSeverity("success");
      setShowErrorSnackbar(true);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to download Aadhaar documents.";
      setSnackbarMessage(message);
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  };
  const getMaxDOB = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    return today.toISOString().split("T")[0]; // yyyy-mm-dd
  };
  const handleDownloadDL = async (userId: string) => {
    try {
      const response = await axiosInstance.get(
        `/users/dashboard/download-dl?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const { code, data } = response.data || {};
      const userDocMap = data?.userDocMap;

      if (code !== 2000 || !userDocMap) {
        throw new Error("Driving License documents not found.");
      }

      if (userDocMap.FRONT) {
        window.open(userDocMap.FRONT, "_blank");
      }

      if (userDocMap.BACK) {
        window.open(userDocMap.BACK, "_blank");
      }

      setSnackbarMessage(
        "Driving License FRONT and BACK Downloaded Successfully",
      );
      setSnackbarSeverity("success");
      setShowErrorSnackbar(true);
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to open Driving License.";
      setSnackbarMessage(message);
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  };

  return (
    <div className="mb-10">
      <div className="flex bg-white min-h-80 box-shadow p-3 rounded-xl mx-16 mt-10">
        <div className="w-full">
          <Grid container spacing={5} className="w-full flex justify-between">
            <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  <IconButton onClick={() => navigate("/userdetails")}>
                    <ArrowBackIcon />
                  </IconButton>
                  Edit Rider Detail
                </h2>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <form className="p-8" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  First Name
                </Typography>
                <TextField
                  fullWidth
                  name="firstName"
                  placeholder="Enter first name"
                  value={fieldvalueData.firstName}
                  onChange={handleChange}
                  InputProps={{
                    style: { backgroundColor: "#f0f0f0", height: "40px" },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  Last Name
                </Typography>
                <TextField
                  fullWidth
                  name="lastName"
                  placeholder="Enter last name"
                  value={fieldvalueData.lastName}
                  onChange={handleChange}
                  InputProps={{
                    style: { backgroundColor: "#f0f0f0", height: "40px" },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  Mobile Number
                </Typography>

                <TextField
                  fullWidth
                  name="mobile"
                  value={fieldvalueData.mobile} // Changed from defaultValue to value
                  onChange={handleChange}
                  InputProps={{
                    style: {
                      backgroundColor: "#f0f0f0",
                      height: "40px",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Grid>


            </Grid>

            <Grid container spacing={2} className="pt-5 flex">
              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  Vehicle Number
                </Typography>

                <TextField
                  fullWidth
                  name="vehicleNo"
                  placeholder="Vehicle Number"
                  value={fieldvalueData.vehicleNo} // Changed from defaultValue to value
                  onChange={handleChange}
                  InputProps={{
                    style: {
                      backgroundColor: "#f0f0f0",
                      height: 40,
                      cursor: userData.isActive ? "not-allowed" : "pointer",
                    },
                  }}
                  disabled={userData.isActive}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  Aadhaar Number
                </Typography>

                <TextField
                  fullWidth
                  name="aadhaarNumber"
                  placeholder="Aadhaar Number"
                  variant="outlined"
                  value={userData.aadhaarNumber}
                  InputProps={{
                    readOnly: true,
                    style: {
                      backgroundColor: "#f0f0f0",
                      cursor: "not-allowed",
                      height: "40px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <img
                          src={"/assets/document.svg"}
                          alt="document"
                          onClick={() =>
                            handleDownloadAadhaar(userData.userId, userData)
                          }
                          style={{
                            cursor: "pointer",
                            width: 20,
                            height: 20,
                            marginLeft: 8,
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
                <p className="text-end">
                  {userData?.kycStatus !== "VERIFIED" && (
                    <Button
                      onClick={() => adharCardVerification(userId)}
                      disabled={isSubmitting}
                      style={{
                        color: "Green",
                        borderRadius: "40px",
                        textTransform: "none",
                        fontSize: "16px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Aadhaar Verify
                    </Button>
                  )}
                </p>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  DL Number
                </Typography>

                <TextField
                  fullWidth
                  name="dlNumber"
                  placeholder="DL Number"
                  value={userData.dlNumber}
                  InputProps={{
                    style: {
                      backgroundColor: "#f0f0f0",
                      cursor: "not-allowed",
                      height: "40px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <img
                          src={"/assets/document.svg"}
                          alt="document"
                          onClick={() => handleDownloadDL(userData.userId)}
                          style={{
                            cursor: "pointer",
                            width: 20,
                            height: 20,
                            marginLeft: 8,
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  Aadhaar Address
                </Typography>

                <TextField
                  fullWidth
                  placeholder="Address"
                  name="address"
                  value={fieldvalueData.address} // Changed to use fieldvalueData and added name
                  onChange={handleChange} // Added onChange
                  InputProps={{
                    style: {
                      backgroundColor: "#f0f0f0",
                      height: "40px",
                    },
                  }}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth variant="outlined">
                  <Typography className="text-left" fontWeight={700} mb={0.5}>
                    Gender
                  </Typography>

                  <Select
                    name="gender"
                    value={fieldvalueData.gender} // Changed from defaultValue to value
                    onChange={handleGenderChange} // Added proper onChange handler
                    sx={{
                      width: "100%",
                      textAlign: "left",
                      backgroundColor: "#f0f0f0",
                      height: "40px",
                    }}
                  >
                    <MenuItem value={"Male"}>Male</MenuItem>
                    <MenuItem value={"Female"}>Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography className="text-left" fontWeight={700} mb={0.5}>
                  Date Of Birth (At least 18 years old)
                </Typography>

                <TextField
                  type="date"
                  fullWidth
                  name="dateOfBirth"
                  value={fieldvalueData.dateOfBirth} // Already correct
                  onChange={handleChange}
                  inputProps={{
                    max: getMaxDOB(), // 👈 only 18+ allowed
                  }}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    "& .MuiInputBase-input": {
                      backgroundColor: "#f0f0f0",
                      height: "10px",
                    },
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} className="pt-10 flex justify-end">
              {userData.isActive ? (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{
                    cursor:
                      getStatusValue === "PENDING" ? "not-allowed" : "pointer",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px" }}>
                   {/* <div><Button
                      type="submit"
                      disabled={isSubmitting || getStatusValue === "PENDING"}
                      style={{
                        backgroundColor: "#000",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        width: "100%",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      {isSubmitting
                        ? "Updating..."
                        : getStatusValue === "PENDING"
                          ? "Pending"
                          : getStatusValue === "UNLOCK"
                            ? "Motor Lock"
                            : "Motor Unlock"}
                    </Button>
                    </div> */}
                    <Button
                      onClick={() => {
                        updateDataRequest(userId);
                      }}
                      disabled={isSubmitting}
                      style={{
                        backgroundColor: "red",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        width: "100%",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      {isSubmitting ? "Updating..." : "Update Info"}
                    </Button>
                    <Button
                      onClick={() => {
                        if (rideEnd === "inprogress" || rideEnd === "onhold") {
                          rideEndRequest(userData.userId);
                        }
                      }}
                      disabled={
                        isSubmitting ||
                        rideEnd === "ride_end_initiated" ||
                        rideEnd === "ride_end_completed"
                      }
                      style={{
                        backgroundColor:
                          rideEnd === "inprogress" || rideEnd === "onhold"
                            ? "red"
                            : "grey",
                        cursor:
                          rideEnd === "ride_end_initiated" ||
                            rideEnd === "ride_end_completed"
                            ? "not-allowed"
                            : "pointer",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        width: "100%",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      {isSubmitting ? "Processing..." : "Ride End Request"}
                    </Button>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} sm={6}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Button
                      onClick={() => {
                        updateDataRequest(userId);
                      }}
                      disabled={isSubmitting}
                      style={{
                        backgroundColor: "red",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        width: "100%",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      {isSubmitting ? "Updating..." : "Update Info"}
                    </Button>
                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      style={{
                        backgroundColor: "#000",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        width: "100%",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      {isSubmitting ? "Updating..." : "Update Vehicle Number"}
                    </Button>
                  </div>
                </Grid>
              )}
            </Grid>
          </form>
        </div>
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundColor: "#00C853",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <Typography sx={{ fontSize: 40, color: "white" }}>✔</Typography>
          </Box>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Operation Successful!
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "40px",
            }}
            onClick={() => setOpen(false)}
          >
            Continue to Dashboard
          </Button>
        </Box>
      </Modal>
      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowErrorSnackbar(false)}
      >
        <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
      </Snackbar>
    </div>
  );
};

export default FleetDailyReport;
